{
  "name": "gung-b2b",
  "version": "1.0.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "postinstall": "node scripts/patch-pdfjs-vite-ignore.js",
    "build": "node --max_old_space_size=10000 node_modules/@angular/cli/bin/ng build",
    "test": "ng test",
    "test:ci": "ng test --watch=false --no-progress",
    "test:ci:pim": "ng test gung-common --watch=false --no-progress && ng test gung-list --watch=false --no-progress && ng test cloud-pim-base --watch=false --no-progress",
    "test:ci:libs": "ng test gung-common --watch=false --no-progress && ng test gung-list --watch=false --no-progress && ng test gung-standard --watch=false --no-progress && ng test gung-dashboard --watch=false --no-progress",
    "test:ci:bc": "npm run test:ci:libs && ng test gung-standard-bc --watch=false --no-progress",
    "test:ci:epicor": "npm run test:ci:libs && ng test gung-standard-epicor --watch=false --no-progress",
    "test:ci:erpless": "npm run test:ci:libs && ng test gung-standard-erpless --watch=false --no-progress",
    "test:ci:fortnox": "npm run test:ci:libs && ng test gung-standard-fortnox --watch=false --no-progress",
    "test:ci:garp": "npm run test:ci:libs && ng test gung-standard-garp --watch=false --no-progress",
    "test:ci:jeeves": "npm run test:ci:libs && ng test gung-standard-jeeves --watch=false --no-progress",
    "test:ci:m2m": "npm run test:ci:libs && ng test gung-standard-m2m --watch=false --no-progress",
    "test:ci:m3": "npm run test:ci:libs && ng test gung-standard-m3 --watch=false --no-progress",
    "test:ci:mertex": "npm run test:ci:libs && ng test gung-standard-mertex --watch=false --no-progress",
    "test:ci:parallel:pim": "concurrently --kill-others-on-fail -n common,list,pim \"ng test gung-common --watch=false --no-progress\" \"ng test gung-list --watch=false --no-progress\" \"ng test cloud-pim-base --watch=false --no-progress\"",
    "test:ci:parallel:bc": "concurrently --kill-others-on-fail -n common,list,standard,dashboard,bc \"ng test gung-common --watch=false --no-progress\" \"ng test gung-list --watch=false --no-progress\" \"ng test gung-standard --watch=false --no-progress\" \"ng test gung-dashboard --watch=false --no-progress\" \"ng test gung-standard-bc --watch=false --no-progress\"",
    "test:ci:parallel:epicor": "concurrently --kill-others-on-fail -n common,list,standard,dashboard,epicor \"ng test gung-common --watch=false --no-progress\" \"ng test gung-list --watch=false --no-progress\" \"ng test gung-standard --watch=false --no-progress\" \"ng test gung-dashboard --watch=false --no-progress\" \"ng test gung-standard-epicor --watch=false --no-progress\"",
    "test:ci:parallel:erpless": "concurrently --kill-others-on-fail -n common,list,standard,dashboard,erpless \"ng test gung-common --watch=false --no-progress\" \"ng test gung-list --watch=false --no-progress\" \"ng test gung-standard --watch=false --no-progress\" \"ng test gung-dashboard --watch=false --no-progress\" \"ng test gung-standard-erpless --watch=false --no-progress\"",
    "test:ci:parallel:fortnox": "concurrently --kill-others-on-fail -n common,list,standard,dashboard,fortnox \"ng test gung-common --watch=false --no-progress\" \"ng test gung-list --watch=false --no-progress\" \"ng test gung-standard --watch=false --no-progress\" \"ng test gung-dashboard --watch=false --no-progress\" \"ng test gung-standard-fortnox --watch=false --no-progress\"",
    "test:ci:parallel:garp": "concurrently --kill-others-on-fail -n common,list,standard,dashboard,garp \"ng test gung-common --watch=false --no-progress\" \"ng test gung-list --watch=false --no-progress\" \"ng test gung-standard --watch=false --no-progress\" \"ng test gung-dashboard --watch=false --no-progress\" \"ng test gung-standard-garp --watch=false --no-progress\"",
    "test:ci:parallel:jeeves": "concurrently --kill-others-on-fail -n common,list,standard,dashboard,jeeves \"ng test gung-common --watch=false --no-progress\" \"ng test gung-list --watch=false --no-progress\" \"ng test gung-standard --watch=false --no-progress\" \"ng test gung-dashboard --watch=false --no-progress\" \"ng test gung-standard-jeeves --watch=false --no-progress\"",
    "test:ci:parallel:m2m": "concurrently --kill-others-on-fail -n common,list,standard,dashboard,m2m \"ng test gung-common --watch=false --no-progress\" \"ng test gung-list --watch=false --no-progress\" \"ng test gung-standard --watch=false --no-progress\" \"ng test gung-dashboard --watch=false --no-progress\" \"ng test gung-standard-m2m --watch=false --no-progress\"",
    "test:ci:parallel:m3": "concurrently --kill-others-on-fail -n common,list,standard,dashboard,m3 \"ng test gung-common --watch=false --no-progress\" \"ng test gung-list --watch=false --no-progress\" \"ng test gung-standard --watch=false --no-progress\" \"ng test gung-dashboard --watch=false --no-progress\" \"ng test gung-standard-m3 --watch=false --no-progress\"",
    "test:ci:parallel:mertex": "concurrently --kill-others-on-fail -n common,list,standard,dashboard,mertex \"ng test gung-common --watch=false --no-progress\" \"ng test gung-list --watch=false --no-progress\" \"ng test gung-standard --watch=false --no-progress\" \"ng test gung-dashboard --watch=false --no-progress\" \"ng test gung-standard-mertex --watch=false --no-progress\"",
    "lint": "ng lint",
    "e2e": "ng e2e",
    "watch-libs": "concurrently \"ng build gung-standard --watch\" \"ng build gung-list --watch\" \"ng build gung-common --watch\"",
    "build-standard-libs": "ng build gung-common && ng build gung-list && ng build gung-dynamic-pdf && ng build gung-standard && ng build gung-dashboard",
    "build-libs-standard": "ng build gung-common && ng build gung-list && ng build gung-dynamic-pdf && ng build gung-standard && ng build gung-dashboard",
    "build-libs": "ng build gung-common && ng build gung-list && ng build gung-dynamic-pdf && ng build gung-standard && ng build gung-dashboard && ng build gung-standard-jeeves",
    "build-libs-jeeves": "npm run build-libs",
    "build-libs-jeeves-cloud": "npm run build-libs-jeeves",
    "build-libs-garp": "ng build gung-common && ng build gung-list && ng build gung-dynamic-pdf && ng build gung-standard && ng build gung-dashboard && ng build gung-standard-garp",
    "build-libs-bc": "ng build gung-common && ng build gung-list && ng build gung-dynamic-pdf && ng build gung-standard && ng build gung-dashboard && ng build gung-standard-bc",
    "build-libs-fortnox": "ng build gung-common && ng build gung-list && ng build gung-dynamic-pdf && ng build gung-standard && ng build gung-dashboard && ng build gung-standard-fortnox",
    "build-libs-m3": "ng build gung-common && ng build gung-list && ng build gung-dynamic-pdf && ng build gung-standard && ng build gung-dashboard && ng build gung-standard-m3",
    "build-libs-epicor": "ng build gung-common && ng build gung-list && ng build gung-dynamic-pdf && ng build gung-standard && ng build gung-dashboard && ng build gung-standard-epicor",
    "build-libs-m2m": "ng build gung-common && ng build gung-list && ng build gung-dynamic-pdf && ng build gung-standard && ng build gung-dashboard && ng build gung-standard-m2m",
    "build-libs-buyer-portal": "ng build gung-common && ng build gung-list && ng build gung-dynamic-pdf && ng build gung-standard && ng build gung-dashboard && ng build buyer-portal-base",
    "build-libs-all": "ng build gung-common && ng build gung-list && ng build gung-dynamic-pdf && ng build gung-standard && ng build gung-dashboard && ng build gung-standard-jeeves && ng build gung-standard-garp && ng build gung-standard-bc && ng build gung-standard-fortnox && ng build gung-standard-m3 && ng build gung-standard-m2m && ng build gung-standard-epicor && ng build gung-standard-erpless && ng build gung-standard-mertex",
    "build-libs-erpless": "ng build gung-common && ng build gung-list && ng build gung-dynamic-pdf && ng build gung-standard && ng build gung-dashboard && ng build gung-standard-erpless",
    "build-libs-mertex": "ng build gung-common && ng build gung-list && ng build gung-dynamic-pdf && ng build gung-standard && ng build gung-dashboard && ng build gung-standard-mertex",
    "build-libs-vismanxt": "ng build gung-common && ng build gung-list && ng build gung-dynamic-pdf && ng build gung-standard && ng build gung-dashboard",
    "build-libs-pyramid": "ng build gung-common && ng build gung-list && ng build gung-dynamic-pdf && ng build gung-standard && ng build gung-dashboard",
    "build-hl-customer-1600": "ng lint hl-display & ng build hl-display --configuration customer-1600",
    "build-hl-sales-1210": "ng lint hl-display & ng build hl-display --configuration sales-1210",
    "build-hl-sales-1710": "ng lint hl-display & ng build hl-display --configuration sales-1710",
    "build-capstone": "ng lint ref & ng build ref -c production",
    "build-fortiva": "ng lint fortiva & ng build fortiva --configuration production",
    "build-pocketgrossisten": "ng build pocketgrossisten --configuration production",
    "build-cult": "ng build cult --configuration production",
    "build-colmec": "ng build colmec -c production",
    "compodoc": "npx compodoc -p tsconfig.json",
    "deploy-hl-sales": "bash ./projects/hl-display/deploy-sales.sh",
    "build-pim": "ng build gung-utils && ng build gung-common && ng build gung-list && ng build gung-list-pim && ng build cloud-pim-base",
    "build-pim-markslojd": "npm run build-pim && ng build cloud-pim-markslojd --configuration production",
    "extract-translations-pim": "ngx-translate-extract --input ./**/cloud-pim-base/src/ ./**/gung-list/src/ ./**/gung-list-pim/ --output ./projects/cloud-pim-base/src/lib/i18n/{en,se,no}.json --sort",
    "extract-translations-standard": "ngx-translate-extract --input ./**/gung-standard/src/ ./**/gung-list/src/ ./**/gung-dashboard/src --output ./i18n/standard.json --sort",
    "extract-translations-standard-jeeves": "ngx-translate-extract --input  ./**/gung-standard-jeeves/src/ --output ./i18n/standard-jeeves.json --sort"
  },
  "lint-staged": {
    "*.ts": [
      "eslint --fix"
    ],
    "*.html": [
      "eslint --fix"
    ]
  },
  "private": true,
  "dependencies": {
    "@adyen/adyen-web": "^6.1.0",
    "@angular-devkit/core": "^20.3.37",
    "@angular-eslint/schematics": "^20.7.0",
    "@angular/animations": "^20.3.32",
    "@angular/cdk": "^20.0.0",
    "@angular/common": "^20.3.32",
    "@angular/compiler": "^20.3.32",
    "@angular/core": "^20.3.32",
    "@angular/forms": "^20.3.32",
    "@angular/localize": "^20.3.32",
    "@angular/platform-browser": "^20.3.32",
    "@angular/platform-browser-dynamic": "^20.3.32",
    "@angular/router": "^20.3.32",
    "@aws-amplify/ui-angular": "^5.0.16",
    "@bluehalo/ngx-leaflet": "^20.0.0",
    "@bluehalo/ngx-leaflet-markercluster": "^20.0.3",
    "@ctrl/tinycolor": "^4.1.0",
    "@fortawesome/fontawesome-free": "^6.4.0",
    "@fortawesome/fontawesome-pro": "^6.4.0",
    "@kolkov/angular-editor": "~2.1.0",
    "@ng-bootstrap/ng-bootstrap": "^19.0.0",
    "@ngrx/effects": "^20.0.0",
    "@ngrx/entity": "^20.0.0",
    "@ngrx/store": "^20.0.0",
    "@ngrx/store-devtools": "^20.0.0",
    "@ngx-translate/core": "^15.0.0",
    "@sentry/browser": "^7.120.4",
    "@stripe/stripe-js": "^8.1.0",
    "@types/leaflet": "^1.9.12",
    "@types/leaflet.markercluster": "^1.5.4",
    "angular-gridster2": "^20.0.0",
    "angular-oauth2-oidc": "^13.0.1",
    "angular-oauth2-oidc-jwks": "^13.0.1",
    "angulartics2": "^14.0.0",
    "aws-amplify": "^6.3.6",
    "bootstrap": "^5.3.3",
    "chart.js": "^3.8.2",
    "date-fns": "^3.6.0",
    "dm-fabric": "^5.1.17",
    "dot-object": "^2.1.4",
    "dynamsoft-javascript-barcode": "^9.6.42",
    "exifreader": "^4.31.0",
    "file-saver": "^2.0.5",
    "flag-icons": "^7.2.3",
    "font-awesome": "^4.7.0",
    "gung-pim-theme": "file:../gung-pim-theme",
    "gung-theme": "file:../gung-theme",
    "hammerjs": "^2.0.8",
    "html2canvas": "^1.4.1",
    "html5-qrcode": "^2.2.1",
    "leaflet": "^1.9.4",
    "leaflet.markercluster": "^1.5.3",
    "lodash-es": "^4.17.21",
    "ng-sortgrid": "^20.0.0",
    "ng-zorro-antd": "^20.4.4",
    "ng2-charts": "^3.1.2",
    "ng2-pdf-viewer": "^10.4.0",
    "ngx-image-zoom": "^1.0.1",
    "ngx-indexed-db": "^11.0.2",
    "ngx-infinite-scroll": "^20.0.0",
    "ngx-owl-carousel-o": "^20.1.0",
    "ngx-scanner-qrcode": "^1.6.9",
    "odata-query": "^6.7.1",
    "pdfjs-dist": "^4.8.69",
    "rxjs": "^7.8.1",
    "tslib": "^2.6.3",
    "url-search-params-polyfill": "^8.1.1",
    "uuid": "^11.1.1",
    "xlsx": "^0.18.5",
    "xlsx-js-style": "^1.2.0",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^20.3.37",
    "@angular-eslint/builder": "^20.7.0",
    "@angular-eslint/eslint-plugin": "20.7.0",
    "@angular-eslint/eslint-plugin-template": "20.7.0",
    "@angular-eslint/template-parser": "^20.7.0",
    "@angular/build": "^20.3.37",
    "@angular/cli": "^20.3.37",
    "@angular/compiler-cli": "^20.3.32",
    "@angular/language-service": "^20.3.32",
    "@aws-amplify/cli": "^12.12.2",
    "@types/file-saver": "^2.0.5",
    "@types/jasmine": "^5.1.5",
    "@types/node": "^20.15.1",
    "@typescript-eslint/eslint-plugin": "^8.33.1",
    "@typescript-eslint/parser": "^8.33.1",
    "@vifraa/fastsite": "~1.2.10",
    "ajv": "^8.11.0",
    "concurrently": "^10.0.3",
    "eslint": "^8.17.0",
    "eslint-config-prettier": "^8.5.0",
    "eslint-plugin-import": "latest",
    "eslint-plugin-jsdoc": "latest",
    "eslint-plugin-prefer-arrow": "latest",
    "eslint-plugin-prettier": "^4.2.1",
    "husky": "^9.1.7",
    "karma": "^6.4.4",
    "karma-chrome-launcher": "^3.2.0",
    "karma-coverage": "^2.2.1",
    "karma-coverage-istanbul-reporter": "^3.0.3",
    "karma-jasmine": "^5.1.0",
    "karma-jasmine-html-reporter": "^2.1.0",
    "lint-staged": "^16.1.2",
    "ng-packagr": "^20.3.2",
    "prettier": "^3.3.2",
    "prettier-eslint": "^16.3.0",
    "slash": "^5.1.0",
    "ts-node": "^10.9.2",
    "typescript": "^5.4.5"
  },
  "overrides": {
    "jsrsasign": "^11.0.0",
    "postcss": "^8.5.20",
    "shell-quote": "^1.10.0",
    "glob": "^13.0.6",
    "karma": {
      "glob": "^7.1.7",
      "minimatch": "^3.0.4"
    },
    "minimatch": "^10.2.5",
    "brace-expansion": "^5.0.7",
    "piscina": "^5.3.2",
    "@aws-amplify/ui-angular": {
      "nanoid": "^3.3.18"
    },
    "@angular-devkit/core": {
      "chokidar": "4.0.3"
    },
    "@angular/compiler-cli": {
      "chokidar": "4.0.3"
    },
    "@angular-devkit/build-angular": {
      "webpack-dev-middleware": "^7.4.6"
    }
  }
}
